<template>
  <div>
    In
    <strong>{{ name }}</strong>
    component served from
    <em>{{ message }}</em>
  </div>
</template>

<script>
export default {
  name: 'DkBusinessEntityTypeDetails',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      name: 'DkBusinessEntityTypeDetails',
    }
  },
}
</script>

<style scoped></style>
